const PANORAMA_GA = {
  dev: {
    indoor: [
      'BOUTIQUE VIEW 1',
      'FREE SPIRIT',
      'PINNACLE VIEW 1',
      'BY THE BAY & 50TH ANNIVERSARY',
      'CLUB CHANDON'
    ],
    outdoor: ['CABANA VIEW 2']
  },
  prod: {
    indoor: [
      'A WORLD OF POSSIBILITIES',
      'BOUTIQUE VIEW 1',
      'BY THE BAY & 50TH ANNIVERSARY',
      'CHANDON COLLECTION',
      'CHANDON GIFTING',
      'CLUB CHANDON',
      'CLUB CHANDON 1',
      'CLUB CHANDON 2',
      'FREE SPIRIT',
      'HOST WITH HEART',
      'HOST WITH HEART SELECTION',
      'PINNACLE VIEW 1',
      'PINNACLE VIEW 2',
      'RARITY TABLE VIEW 1',
      'RARITY TABLE VIEW 2',
      'ROOTS COLLECTION'
    ],
    outdoor: [
      'CABANA VIEW 1',
      'CABANA VIEW 2',
      'CABANA VIEW 3',
      'CHANDON GARDEN',
      'CHANDON GARDEN 1',
      'CHANDON GARDEN 2',
      'CHANDON GARDEN 3',
      'CLUB LOUNGE 1',
      'CLUB LOUNGE 2',
      'CLUB LOUNGE 3',
      'CLUB LOUNGE 4',
      'CLUB LOUNGE 5',
      'CLUB LOUNGE 6',
      'CROSSROADS 1',
      'CROSSROADS 2',
      'ENTRANCE',
      'EPICUREAN HUB 1',
      'EPICUREAN HUB 2',
      'EPICUREAN HUB 3',
      'EPICUREAN HUB 4',
      'KITCHEN GARDEN VIEW 1',
      'KITCHEN GARDEN VIEW 2',
      'OAK GROVE VIEW 1',
      'OAK GROVE VIEW 2',
      'OAK GROVE VIEW 3',
      'OAK GROVE VIEW 4',
      'OAK GROVE VIEW 5',
      'OAK GROVE VIEW 6',
      'OAK GROVE VIEW 7',
      'OAK GROVE VIEW 8',
      'THE COVE VIEW 1',
      'THE COVE VIEW 2',
      'THE COVE VIEW 3',
      'THE COVE VIEW 4',
      'THE COVE VIEW 5',
      'THE COVE VIEW 6',
      'WRIGHTS LANDING VIEW 1',
      'WRIGHTS LANDING VIEW 2',
      'YOUNTVILLE'
    ]
  }
}
export default PANORAMA_GA[process.env.NODE_ENV || 'dev']
